<table
	mat-table
	class="list-container mb-3"
	[dataSource]="dataSource"
	matSort
	matSortActive="{{ sort.active }}"
	matSortDisableClear
	matSortDirection="{{ sort.direction }}"
>
	<ng-container matColumnDef="empty">
		<th mat-header-cell *matHeaderCellDef class="text-center">
			<em>No associated documents</em>
		</th>
	</ng-container>

	<ng-container matColumnDef="title">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
		<td mat-cell *matCellDef="let doc">
			{{ doc.title }}
		</td>
	</ng-container>

	<ng-container matColumnDef="uploadedOn">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Upload Date</th>
		<td mat-cell *matCellDef="let doc">
			{{ doc.uploadedOn | date: 'shortDate':'utc' }}
		</td>
	</ng-container>

	<ng-container matColumnDef="hiddenFromCustomer">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			Hidden From Customer
		</th>
		<td mat-cell *matCellDef="let doc">
			<mat-icon *ngIf="doc.hideFromCustomer">done</mat-icon>
		</td>
	</ng-container>
	<ng-container matColumnDef="hiddenFromFieldWorker">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			Hidden From Field Worker
		</th>
		<td mat-cell *matCellDef="let doc">
			<mat-icon *ngIf="doc.hideFromFieldWorker">done</mat-icon>
		</td>
	</ng-container>
	<ng-container matColumnDef="includedInInvoicing">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			Included In Invoicing
		</th>
		<td mat-cell *matCellDef="let doc">
			<mat-icon *ngIf="doc.includeInInvoicing">done</mat-icon>
		</td>
	</ng-container>

	<ng-container matColumnDef="download">
		<th mat-header-cell *matHeaderCellDef>Download</th>
		<td mat-cell *matCellDef="let doc">
			<button
				type="button"
				mat-icon-button
				color="primary"
				(click)="downloadDocument(doc.id)"
			>
				<mat-icon>archive</mat-icon>
			</button>
		</td>
	</ng-container>
	<ng-container matColumnDef="preview">
		<th mat-header-cell *matHeaderCellDef>Preview</th>
		<td mat-cell *matCellDef="let doc">
			<button
				type="button"
				mat-icon-button
				color="primary"
				(click)="previewDocument(doc.id)"
			>
				<mat-icon>picture_in_picture</mat-icon>
			</button>
		</td>
	</ng-container>

	<ng-container matColumnDef="edit">
		<th mat-header-cell *matHeaderCellDef>Edit</th>
		<td mat-cell *matCellDef="let doc; let i = index">
			<button
				type="button"
				mat-icon-button
				(click)="editDocument(doc)"
				color="primary"
			>
				<mat-icon>edit</mat-icon>
			</button>
		</td>
	</ng-container>

	<ng-container matColumnDef="delete">
		<th mat-header-cell *matHeaderCellDef>Delete</th>
		<td mat-cell *matCellDef="let doc">
			<button
				type="button"
				mat-icon-button
				color="warn"
				rpsharedConfirm="Delete document?"
				(onConfirmed)="deleteDocument(doc.id)"
			>
				<mat-icon>delete</mat-icon>
			</button>
		</td>
	</ng-container>

	<tr
		mat-header-row
		*matHeaderRowDef="resultColumns"
		[class.hidden]="dataSource.data?.length < 1"
	></tr>
	<tr
		mat-header-row
		*matHeaderRowDef="emptyColumns"
		[class.hidden]="dataSource.data?.length > 0"
	></tr>
	<tr
		mat-row
		*matRowDef="let doc; columns: resultColumns"
		[@animateList]
	></tr>
</table>

<div fxLayout fxLayoutAlign="space-between center">
	<mat-paginator
		class.hidden="true"
		pageSize="5"
		[pageSizeOptions]="[5, 10]"
	></mat-paginator>
	<button
		type="button"
		class="mr-4"
		(click)="addDocument()"
		mat-mini-fab
		color="primary"
		matTooltip="Upload Document"
	>
		<mat-icon>add</mat-icon>
	</button>
</div>
